import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

// const languageKey = 'language'
// export const getLanguage = () => Cookies.get(languageKey)
// export const setLanguage = (language: string) => Cookies.set(languageKey, language)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
const tokenKey = 'organizationName'
const inFifteenMinutes = new Date(new Date().getTime() + 5 * 60 * 60 * 1000)
export const getOrganizationName = () => Cookies.get(tokenKey)
export const setOrganizationName = (token: string) => Cookies.set(tokenKey, token, {expires: inFifteenMinutes})

export const removeCookies = () => {
  Cookies.remove(tokenKey)
  Cookies.remove('organizationId')
  Cookies.remove('wyOrganizationId')
}


